
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/tutorials/gateways-module-tutorial",
      function () {
        return require("private-next-pages/docs/antara/tutorials/gateways-module-tutorial/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/tutorials/gateways-module-tutorial"])
      });
    }
  